<template>
  <div class="page-association-mining">
    <div class="query-bar">
      <div class="query-left">
        <el-form inline>
          <el-form-item label="乡镇选择">
            <el-select
              class="form-select"
              popper-class="form-select-dropdown"
              :popper-append-to-body="false"
              v-model="queryForm.region"
              @change="getData"
            >
              <el-option
                v-for="item in regionList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="空气指标" label-width="110px">
            <el-select
              class="form-select"
              popper-class="form-select-dropdown"
              :popper-append-to-body="false"
              v-model="queryForm.pollutant"
              @change="getData"
            >
              <el-option
                v-for="item in pollutantList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-date-picker
        v-model="checkDaterange"
        :clearable="false"
        class="form-time-select"
        type="daterange"
        placeholder="选择日期"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        popper-class="form-time-select-dropdown form-time-picker-dropdown"
        @change="getData"
      ></el-date-picker>
    </div>
    <ClipBox class="content-wrapper">
      <div class="title-bar">
        <h2>火点报警次数-{{ selectPollutant }}</h2>
        <div>关联度:{{ gradient }}</div>
      </div>
      <div class="chart-wrapper">
        <ChartScatter :chart-data="chartData" :y-name="selectPollutant" />
      </div>
      <div class="info-bar">
        <div class="info-box">
          {{ selectRegion }}报警次数和{{ selectPollutant }}关联度为{{
            gradient
          }}
        </div>
      </div>
    </ClipBox>
  </div>
</template>

<script>
  import ClipBox from "@/components/ClipBox/index.vue";
  import ChartScatter from "./ChartScatter/Chart.vue";
  import { townshipList } from "@/utils/common";
  import ecStat from "echarts-stat";
  import { getAlarmrelationaqiData } from "@/api/dataCenter";
  import dayjs from "dayjs";
  export default {
    name: "AssociationMining",
    components: { ClipBox, ChartScatter },
    data() {
      return {
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
        chartData: [],
        regionList: townshipList,
        pollutantList: [
          { label: "PM2.5", value: "pm25" },
          { label: "PM10", value: "pm10" },
          { label: "SO2", value: "so2" },
          { label: "NO2", value: "no2" },
          { label: "CO", value: "co" },
          { label: "O3", value: "o3" },
        ],
        queryForm: {
          region: "008",
          pollutant: "pm25",
          daterange: [],
        },
      };
    },
    computed: {
      selectRegion({ queryForm, regionList }) {
        const selectData = regionList.find(
          (item) => item.value === queryForm.region
        );
        return selectData?.label;
      },
      selectPollutant({ queryForm, pollutantList }) {
        const selectData = pollutantList.find(
          (item) => item.value === queryForm.pollutant
        );
        return selectData?.label;
      },
      gradient({ chartData }) {
        if (chartData.length) {
          try {
            const { parameter } = ecStat.regression("linear", chartData);
            return isNaN(parameter.gradient)
              ? "--"
              : +parameter.gradient.toFixed(2);
          } catch (error) {
            return "--";
          }
        }
        return "--";
      },
      // 7 >= 时间周期 >= 31
      checkDaterange: {
        get: ({ queryForm }) => queryForm.daterange,
        set(value) {
          const sTime = dayjs(value[0]);
          const eTime = dayjs(`${value[1]} 23:59:59`);
          const diff = eTime - sTime + 1000;
          if (diff < 7 * 24 * 60 * 60 * 1000) {
            return this.$message.warning("时间周期不得小于7天");
          } else {
            this.queryForm.daterange = value;
          }
          //  else if (diff > 31 * 24 * 60 * 60 * 1000) {
          //   return this.$message.warning("时间周期不得大于31天");
          // }
        },
      },
    },
    created() {
      const today = dayjs();
      const startTime = today.subtract(30, "day");
      this.queryForm.daterange = [
        startTime.format("YYYY-MM-DD"),
        today.format("YYYY-MM-DD"),
      ];
      this.getData();
    },
    methods: {
      getData() {
        // 清空数据
        this.chartData = [];
        const {
          pollutant,
          daterange: [stime, etime],
        } = this.queryForm;
        const params = {
          site: this.selectRegion,
          pollutant,
          stime,
          etime,
        };
        getAlarmrelationaqiData(params).then((res) => {
          const x = res.data.x || [];
          const y = res.data.y || [];
          this.chartData = x
            .map((count, index) => {
              return [+count, +y[index]];
            })
            .filter(([count, pollutant]) => {
              return (
                !isNaN(count) &&
                !isNaN(pollutant) &&
                count != null &&
                pollutant != null
              );
            });
        });
      },
    },
  };
</script>

<style scoped lang="less">
  .page-association-mining {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding-bottom: 20px;
  }

  @query-bar-height: 62px;

  .query-bar {
    height: @query-bar-height;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &::v-deep {
      .el-form-item {
        margin-bottom: 0;
      }
      .el-form-item__label {
        font-size: 18px;
        color: #ffffff;
      }
      .el-select .el-input__inner {
        height: 40px;
        width: 200px;
      }
      .el-range-editor.el-input__inner {
        width: 300px;
        height: 34px;
        padding: 0 10px;
      }
    }
  }

  .content-wrapper {
    width: 100%;
    height: calc(100% - @query-bar-height);
    &::v-deep .clip-box {
      display: flex;
      flex-direction: column;
    }
    .title-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 25px 112px 20px 95px;
      line-height: 30px;
      & > h2 {
        margin: 0;
        font-size: 28px;
        font-weight: bold;
        color: #239cf9;
      }
      & > div {
        font-size: 24px;
        font-weight: 500;
        color: #239cf9;
      }
    }
    .chart-wrapper {
      width: 100%;
      height: 0;
      flex: auto;
    }
    .info-bar {
      box-sizing: border-box;
      padding: 20px 100px;
      .info-box {
        box-sizing: border-box;
        width: 100%;
        height: 52px;
        text-align: center;
        line-height: 50px;
        font-size: 24px;
        font-weight: 500;
        color: #239cf9;
        background: rgba(35, 156, 249, 0.2);
        border: 1px solid #239cf9;
      }
    }
  }
</style>
